export const COLORS_HEX: Record<string, string> = {
  default: '#2F7FEF',
  blue: '#2F7FEF',
  topaz: '#18C4A9',
  pear: '#99CE43',
  orange: '#F8AB4B',
  coral: '#EA5E5E',
  magenta: '#EB60BC',
  purple: '#AA5EEA',
  dusk: '#768BA7',
  cloudy: '#ACBDD3',

  yellow: '#F4EE0F',
  cyan: '#D9FEF8',
  crimson: '#F8D4F8',
  darkBlue: '#68A5FB',
  white: '#FFFFFF',
  boldBlue: '#2D3A55',
}
